export const DESKTOP_MAIN_CONTAINER_NAMES = {
  BACKGROUND: 'BACKGROUND',
  WHEEL: 'WHEEL',
  ODD_CRYSTAL: 'ODD_CRYSTAL',
  GAME_PAD: 'GAME_PAD',
  BONUS_BOARD: 'BONUS_BOARD',
  BUY_BONUS_POPUP: 'BUY_BONUS_POPUP',
  BIG_WIN: 'BIG_WIN',
  CONGRATULATIONS_BONUS_POPUP: 'CONGRATULATIONS_BONUS_POPUP',
}

export const DESKTOP_PRE_BONUS_CONTAINER_NAMES = {
  BACKGROUND: 'BACKGROUND',
  GAME_PAD: 'GAMEPAD',
  PRE_BONUS_CONTENT: 'PRE_BONUS_CONTENT',
}

export const DESKTOP_BONUS_CONTAINER_NAMES = {
  BACKGROUND: 'BACKGROUND',
  WHEEL: 'WHEEL',
  GAME_PAD: 'GAME_PAD',
  BONUS_PAD: 'BONUS_PAD',
  BIG_WIN: 'BIG_WIN',
  CONGRATULATIONS_POPUP: 'CONGRATULATIONS_POPUP',
  CONGRATULATIONS_BONUS_POPUP: 'CONGRATULATIONS_BONUS_POPUP',
  GAME_PAD_FULL: 'GAME_PAD_FULL',
}
